<template>
  <div class="payment-btn">
    <span class="payment-btn__label">Сумма к оплате:</span>
    <v-text-field
      class="payment-btn__input"
      :value="sum"
      @change="(value) => {this.$emit('change', value)}"
      v-money="money"
      outlined
    ></v-text-field>
    <span class="payment-btn__bill">руб.</span>
    <v-btn class="payment-btn__btn" @click="openPaymentDialog">Оплатить</v-btn>
  </div>
</template>

<script>
import { VMoney as money } from "v-money";

export default {
  name: "PaymentBtn",
  directives: {
    money
  },
  model: {
    prop: "sum",
    event: "change"
  },
  props: ["sum", "disabled"],
  data: () => ({
    money: {
      decimal: ",",
      thousands: " "
    }
  }),
  methods: {
    openPaymentDialog() {
      this.$emit("openModal");
    }
  }
};
</script>

<style lang="scss" scoped>
.payment-btn {
  display: flex;
  align-items: center;
  position: relative;

  &__label {
    display: block;
    @extend %important-text;
    font-size: $text-size;
    margin-bottom: 30px;
  }

  &__bill {
    @extend %marker-text;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 30px;
  }

  &__input {
    width: 120px;
    margin: 0 10px 0 20px;
    @extend %important-text;
    font-weight: bold;
  }

  &__btn {
    @extend %o-btn;
    margin-left: 25px;
    margin-bottom: 30px;
  }
}
</style>
